import { jsxs as F, jsx as n } from "react/jsx-runtime";
import { useOnKeyPress as L } from "@placer-ui/hooks";
import U from "classnames";
import { useRef as p, useEffect as D } from "react";
import Z from "react-dom";
import { getPositionClass as k } from "./index.es902.js";
import l from "./index.es903.js";
import { Z_DRAWER as q } from "./index.es191.js";
import { useDrawer as z } from "./index.es904.js";
import { DrawerTemplateHeader as G } from "./index.es905.js";
import { focusFirstElement as J } from "./index.es553.js";
import { onKeyDownEnterAndSpace as w } from "./index.es526.js";
const Q = "drawer-template", le = ({
  children: y,
  header: T,
  isOpen: e,
  position: s = "right",
  width: b = "400px",
  height: E = "100%",
  container: c,
  testId: a = Q,
  snapPoints: S = [],
  activeSnapPoint: R,
  closeThreshold: x = 0.5,
  snapToSequentialPoint: N = !1,
  autoFocus: f = !1,
  setIsOpen: u,
  setActiveSnapPoint: v,
  onDrag: A,
  onRelease: C,
  zIndex: K = q,
  customPosition: H,
  customBorderRadius: M,
  triggerRef: r,
  ...P
}) => {
  const d = p(null), i = p(!1), {
    drawerRef: _,
    rendered: m,
    styles: $,
    handleClose: j,
    handleDragStart: o,
    shouldShowTopHandle: B,
    shouldShowBottomHandle: W
  } = z({
    isOpen: e,
    setIsOpen: u,
    position: s,
    width: b,
    height: E,
    snapPoints: S,
    activeSnapPoint: R,
    setActiveSnapPoint: v,
    closeThreshold: x,
    onDrag: A,
    onRelease: C,
    container: c,
    snapToSequentialPoint: N
  });
  L("Escape", () => u(!1));
  const h = c || (typeof document < "u" ? document.body : null);
  return D(() => {
    setTimeout(() => {
      e && m && d.current && f && J(d);
    }, 300);
  }, [f, e, m, r]), D(() => {
    var t;
    e ? i.current = !0 : !e && i.current && r && ((t = r.current) == null || t.focus());
  }, [e, r]), !m || !h ? null : Z.createPortal(
    /* @__PURE__ */ F(
      "div",
      {
        ref: _,
        className: U(l.drawer, k(s)),
        style: {
          ...$,
          zIndex: K,
          ...H,
          borderRadius: M
        },
        "data-testid": a,
        "data-position": s,
        "data-state": e ? "open" : "closed",
        ...P,
        children: [
          B && /* @__PURE__ */ n(
            "div",
            {
              className: l.handle,
              "data-testid": `${a}-handle`,
              role: "button",
              tabIndex: 0,
              onMouseDown: o,
              onTouchStart: o,
              onKeyDown: (t) => {
                w(t, o);
              },
              "aria-label": "Drag handle"
            }
          ),
          /* @__PURE__ */ n(G, { ...T, onClose: j }),
          /* @__PURE__ */ n("div", { className: l.content, "data-testid": `${a}-content`, ref: d, children: y }),
          W && /* @__PURE__ */ n(
            "div",
            {
              className: l.handle,
              "data-testid": `${a}-handle`,
              role: "button",
              tabIndex: 0,
              onMouseDown: o,
              onTouchStart: o,
              onKeyDown: (t) => {
                w(t, o);
              },
              "aria-label": "Drag handle"
            }
          )
        ]
      }
    ),
    h
  );
};
export {
  Q as DEFAULT_DRAWER_TESTID,
  le as DrawerTemplate
};
//# sourceMappingURL=index.es122.js.map
